<template>
    <div class="artist-direct-booking">
        <div id="preloader" v-if="load" class="preloader"></div>
        <base-modal
            mk="artist-direct-booking"
            :show.sync="show"
            :scroll="false"
            :styles="modalStyles"
        >
            <section class="step-header">
                <button
                    @click="onBack(currentStep.actions.back)"
                    :class="{
                        hidden:
                            !currentStep.actions.back ||
                            (!isAuthed && currentStep.identifier === 'artist-info')
                    }"
                    class="modal-back-btn"
                >
                    <img src="/images/left-arrow-yellow.svg" alt="back-icon" />
                </button>
                <p class="title">{{ currentStep.title }}</p>
                <button @click="() => toggleDirectBooking(false)" class="modal-close-btn">
                    <img src="/images/close-event-modal-yellow.svg" alt="close-icon" />
                </button>
            </section>
            <section class="step-component">
                <component
                    :is="currentStep.component"
                    v-bind.sync="currentStep.props"
                    v-on:update:profile-pic-indx.capture="updateProfilePicIndx"
                    v-on:update:social.capture="updateSocialAuthStatus"
                    v-on:update:cropped-image.capture="updateCroppedImage"
                    @cta-clicked="onContinue"
                    @edit-photo="editPhoto"
                    @is-profile="toggleProfileImage"
                    @autocomplete-loaded="loadAutocomplete"
                    @chosen-artist="chosenArtist"
                ></component>
            </section>
            <section
                v-if="!['welcome', 'login'].includes(currentStep.identifier)"
                class="step-footer"
            >
                <button
                    @click="handleClearClicked"
                    :class="
                        !currentStep.actions.clear && !currentStep.actions.skippable
                            ? 'hidden'
                            : ''
                    "
                    class="step-clear-btn"
                >
                    {{
                        `${currentStep.actions.skippable ? "I'll do this later" : 'Clear All'}`
                    }}
                </button>
                <button
                    :disabled="currentStep.needValidation && validation && validation.$invalid"
                    @click="() => onContinue(currentStep.actions.continue)"
                    class="step-continue-btn"
                >
                    {{ `${currentStep.actions.continue === 'close' ? 'Close' : 'Continue'}` }}
                </button>
            </section>
        </base-modal>
    </div>
</template>
<script>
    import BaseModal from '@/composables/ui/useModal.js'
    import { useArtistDirectBooking } from '@/composables/features/artist-booking/direct-booking/useArtistDirectBooking'
    import useCheckScreen from '@/composables/useCheckScreen.js'

    export default {
        name: 'ArtistDirectBooking',
        components: {
            BaseModal
        },
        props: {
            authed: {
                type: Boolean,
                required: true
            },
            eventId: {
                type: Number,
                required: true
            },
            showModal: {
                type: Boolean,
                required: true
            },
            stepId: {
                type: String,
                required: false
            },
            userId: {
                type: Number,
                required: false
            },
            artistPages: {
                type: Array,
                required: true
            }
        },
        emits: ['update:show-modal'],
        setup(props, context) {
            const {
                autocomplete,
                load,
                authed,
                social,
                show,
                currentStep,
                steps,
                validation,
                ctaClicked,
                userData,
                opportunityInfo,
                editImage,
                toggleProfileImage,
                croppedImage,

                toggleDirectBooking,
                redirectSocial,
                chosenArtist,

                isEditImgAvatar,
                onContinue,
                profilePicIndx,
                onClear,
                onBack,
                updateStep
            } = useArtistDirectBooking(props, context)
            const { isMobile, isTablet } = useCheckScreen()

            return {
                isMobile,
                isTablet,

                autocomplete,
                load,
                social,
                show,
                currentStep,
                steps,
                validation,
                ctaClicked,
                userData,
                opportunityInfo,
                editImage,
                croppedImage,
                toggleProfileImage,

                toggleDirectBooking,
                redirectSocial,
                chosenArtist,

                isEditImgAvatar,
                onContinue,
                profilePicIndx,
                onClear,
                onBack,
                updateStep,

                isAuthed: authed
            }
        },
        methods: {
            handleClearClicked() {
                if (
                    this.currentStep.actions.skippable &&
                    !this.currentStep.actions.clear?.keys
                ) {
                    this.toggleDirectBooking(false)
                } else {
                    this.onClear(this.currentStep.actions.clear.keys)
                }
            },
            loadAutocomplete(autocomplete) {
                this.autocomplete = autocomplete
            },
            editPhoto(photo) {
                this.editImage = photo
                this.updateStep('edit-photo')
            },
            updateProfilePicIndx(indx) {
                this.profilePicIndx = indx
            },
            updateCroppedImage(image) {
                this.croppedImage = image
            },
            updateSocialAuthStatus(status) {
                this.social = status
            }
        },
        data: () => ({
            desktopStyles: {
                modalWrapper: {
                    position: 'fixed',
                    top: '124px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '0px',
                    padding: '48px 40px 32px 40px',
                    background: '#262626',
                    borderRadius: '16px',
                    border: '1px solid #333',
                    width: '100%',
                    maxWidth: '500px',
                    maxHeight: '600px',
                    height: '72vh'
                }
            },
            mobileStyles: {
                modalWrapper: {
                    position: 'fixed',
                    top: '0px',
                    left: '0px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '0px',
                    padding: '28px 16px 40px 16px',
                    borderRadius: '15px',
                    width: '100%',
                    maxWidth: '760px',
                    height: '100vh',
                    background: '#121212'
                }
            },
            tabletStyles: {
                modalWrapper: {
                    position: 'fixed',
                    top: '124px',
                    left: '40px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    gap: '0px',
                    padding: '48px 40px 32px 40px',
                    background: '#262626',
                    borderRadius: '16px',
                    border: '1px solid #333',
                    width: '100%',
                    maxWidth: '500px',
                    maxHeight: '600px',
                    height: '72vh'
                }
            }
        }),
        computed: {
            modalStyles() {
                if (this.isTablet && !this.isMobile) {
                    return this.tabletStyles
                } else if (this.isMobile) {
                    return this.mobileStyles
                } else {
                    return this.desktopStyles
                }
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../sass/_variables.scss';
    .artist-direct-booking {
        p {
            margin-bottom: 0px;
        }
        button {
            border: none;
        }

        position: relative;

        .hidden {
            visibility: hidden;
        }
        .step-header {
            background: inherit;
            width: 100%;
            position: absolute;
            top: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #333;

            .modal-back-btn,
            .modal-close-btn {
                width: 48px;
                height: 48px;
                padding: 12px;
                background: none;

                img {
                    width: 12px;
                    height: 12px;
                    object-fit: cover;
                }
            }
            .title {
                color: #dedede;
                text-align: center;
                @include base-font-16;
                line-height: 125%;
            }
        }
        .step-component {
            width: 100%;
            overflow-y: auto;
            padding-top: 16px;
            padding-bottom: 32px;

            @media screen and (max-width: 768px) {
                padding-top: 32px;
            }
        }
        .step-component {
            -ms-overflow-style: none; /* Internet Explorer 10+ */
            scrollbar-width: none; /* Firefox */
        }
        .container::-webkit-scrollbar {
            display: none; /* Safari and Chrome */
        }
        .step-footer {
            background: inherit;
            position: absolute;
            bottom: 0;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 8px 24px;
            width: 100%;
            border-top: 1px solid #333;

            @media screen and (max-width: 768px) {
                padding-bottom: 40px;
            }

            .step-clear-btn,
            .step-continue-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                border-radius: 120px;
                padding: 10px 24px;
                @include base-font-16;
                line-height: 125%;
                text-transform: capitalize;
            }

            .step-clear-btn {
                background: transparent;
                border: 1px solid #cdeb09;
                color: #cdeb09;
            }
            .step-continue-btn {
                background: #cdeb09;
                color: black;
            }
            .step-continue-btn:disabled {
                opacity: 0.4;
            }
            .step-continue-btn:hover {
                background: #dedede;
            }
        }
    }
</style>
